import { Config } from 'next-i18n-router/dist/types'

export const SUPPORTED_LANGS = ['en', 'fr', 'de', 'ru', 'ja', 'ko', 'es', 'zh']

export const i18nConfig: Config = {
  locales: SUPPORTED_LANGS,
  defaultLocale: 'en',
}

export const localePrefix = 'as-needed'

export type Locale = (typeof i18nConfig)['locales'][number]

export default i18nConfig

export function isValidLocale(locale: string): boolean {
  return i18nConfig.locales.includes(locale)
}

// export function getDefaultLocaleIfNotValid(locale: string): string {
//   if (!isValidLocale(locale)) {
//     return 'en'
//   }
//   return locale
// }
